import React from 'react';
const socials = [{
  label: 'Facebook',
  href: '#',
  path: 'M14 8h3V4h-3c-2.8 0-5 2.2-5 5v2H7v4h2v9h4v-9h3l1-4h-4V9c0-.6.4-1 1-1z'
}, {
  label: 'Instagram',
  href: '#',
  path: 'M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zm5 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm5.5-1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'
}, {
  label: 'Google Business Profile',
  href: '#',
  path: 'M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.7 3-4.3 3-7.3zM12 22c2.7 0 5-.9 6.6-2.4l-3.2-2.5c-.9.6-2 1-3.4 1-2.6 0-4.8-1.8-5.6-4.1H3.1v2.6A10 10 0 0 0 12 22zm-5.6-8a6 6 0 0 1 0-3.9V7.5H3.1a10 10 0 0 0 0 9zM12 6c1.5 0 2.8.5 3.8 1.5l2.9-2.9A10 10 0 0 0 3.1 7.5l3.3 2.6C7.2 7.8 9.4 6 12 6z'
}];
export function SocialIcons() {
  return <ul className="flex gap-3" data-id="element-315" data-mp="3kq4zmvn79l1w">
      {socials.map(s => <li key={s.label} data-id="element-316" data-mp="3krzj05itp53v">
          <a href={s.href} aria-label={s.label} className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-colors duration-150 hover:bg-aqua focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cyan" data-id="element-317" data-mp="3popz2sumo0pa">
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true" data-id="element-318" data-mp="1haed67vevwsw">
              <path d={s.path} fillRule="evenodd" data-id="element-319" data-mp="1cbtdqanzhh5i" />
            </svg>
          </a>
        </li>)}
    </ul>;
}